import React from 'react'
import { useSelector } from 'react-redux';

const SelectedCarBlock = ({ handleNext, target }) => {
  const { bg_id, previewImages,title } = useSelector(state => state.carromm);

  return (
    <div
      key={previewImages || 'no-image'}
      className="selected-car-block"
    >
      <div className="car-box-wrapper">
        <div className="car-box">
          <img
            src={previewImages?.[0]?.url}
            alt={previewImages?.[0]?.url} />
                 {title && <p className="background-title model-heading">{title}</p>}
        </div>
   
      </div>
      {
        target === 'background' ? bg_id && <div className="process-btn-wrap">
          <button
            className="btn btn-process"
            onClick={handleNext}
          >
            Weiter
          </button>
        </div> :
          <div className="process-btn-wrap">
            <button
              className="btn btn-process"
              onClick={handleNext}
            >
              Weiter
            </button>
          </div>
      }

    </div>
  )
}

export default SelectedCarBlock